import axios from 'axios'
import Global from '../Global'
import { sessionHeader } from './main.api';

export default class WeblinkApi {
    constructor(){}

    static create(folder_id = '', ff_id = '', type = '', pw = false, name = '', right = "read", emails = [], max_downloads = 0, duration = 4838400)  { 
        let data = {            
            "file_name": name,
            "right": right,
            "emails": emails,
            "pw": pw,
            "duration": duration
        }  

        if(type == "file"){
            data.file_id = ff_id
            data.folder_id = folder_id
        }
        else {
            data.folder_id = ff_id
        }

        if(max_downloads == '') {
            data.max_downloads = 0
        }

        return axios
        .post(Global.GetAPIURL() + '/weblink/create', JSON.stringify(data), sessionHeader).catch(function(err) {
            if(err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })        
    }

    static revoke(link_id = '') {    
        let data = {            
            "link_id": link_id,            
        }                               
        return axios
        .post(Global.GetAPIURL() + '/weblink/revoke', JSON.stringify(data), sessionHeader).catch(function(err) {
            if(err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })    
    }


    static get(ff_id = '',type = ''){    
        let data = {}
        if(type == 'file'){
            data = {            
                "file_id": ff_id,                            
            }                 
        }
        if(type == 'folder'){
            data = {                     
                "folder_id": ff_id,  
            }                     
        }                               
        return axios
        .post(Global.GetAPIURL() + '/weblink/get', JSON.stringify(data), sessionHeader).catch(function(err) {
            if(err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })    
    }
   
    

}